export * from "/vercel/path0/node_modules/@fuels/react/dist/index.mjs"